export const LAST_ONLINE_LOADING = "LAST_ONLINE_LOADING";
export const LAST_ONLINE_FAILURE = "LAST_ONLINE_FAILURE";
export const LAST_ONLINE_SUCCESS = "LAST_ONLINE_SUCCESS";

export type LastOnlineEntry = {
  DCM: string;
  Date: string;
  Latitude: number;
  Longitude: number;
  AssetNumber: string;
  StealthBatteryVolts?: number | null;
  SolarAmps?: number | null;
  StealthBatteryAmps?: number | null;
  ShorelineVolts?: number | null;
  BMSPackVolts?: number | null;
  ActiveLoad?: boolean;
  UnitWattage?: number | null;
};

export interface LastOnlineLoading {
  type: typeof LAST_ONLINE_LOADING;
}

export interface LastOnlineFailure {
  type: typeof LAST_ONLINE_FAILURE;
}

export interface LastOnlineSuccess {
  type: typeof LAST_ONLINE_SUCCESS;
  payload: LastOnlineEntry[];
}

export type LastOnlineDispatchTypes =
  | LastOnlineLoading
  | LastOnlineFailure
  | LastOnlineSuccess;
